import {AVISO_VENDA_SUSPENSA as C} from './vendaSuspensa.js'

// Mensagem mostrada no chat quando o servidor falha (500, timeout, sem rede).
export const ERRO_CHAT = {
    titulo: 'Não conseguimos processar agora.',
    botao: 'Tentar de novo',
}

export function htmlErroChat() {
    return `<p><strong>${ERRO_CHAT.titulo}</strong> Sua mensagem não foi perdida: toque em tentar de novo. ` +
        `Se continuar, fale com a KSK pelo WhatsApp <a href="${C.hrefWhatsapp}" target="_blank" rel="noopener noreferrer">${C.whatsapp}</a> ` +
        `ou pelo e-mail <a href="${C.hrefEmail}">${C.email}</a>.</p>`
}
